import { CartLines } from './CartLines';

export type { TypeCartLinesProps } from './types';
export default CartLines;
